<template>
  <vx-card id="invoice-container" v-if="requestDetails">
    <invoice-data-view :invoice="invoice" :request="request" :request-details="requestDetails" />
    <div slot="footer">
      <vs-row vs-justify="flex-end" class="print-hidden">
        <vx-card no-shadow card-border class="mb-base flex justify-center">
          <p>{{ surveyRated ? $t('survey.rated') : $t('survey.please_rate') }}</p>
          <star-rating
            :rtl="$vs.rtl"
            class="my-4 flex justify-center vs-con-loading__container"
            :show-rating="false"
            :star-size="25"
            v-model="surveyRate"
            :read-only="surveyRated > 0"
            :rating="surveyRated"
            id="star-loading"
          />
          <vs-button
            color="success"
            class="flex m-auto"
            @click="setRating(surveyRate)"
            v-if="surveyRated === 0 && surveyRate"
          >
            {{ $t('survey.set_rate') }}
          </vs-button>
        </vx-card>
        <!-- <vs-button
          icon-pack="feather"
          icon="icon-x"
          color="danger"
          @click="openCancelConfirm()"
          v-if="invoice.state === 'pending' && ['pending', 'accepted'].includes(request.status)"
        >
          {{ $t('invoices.cancel') }}
        </vs-button> -->
        <vs-button
          color="success"
          id="button-pay-loading"
          class="vs-con-loading__container"
          :disabled="payBtnDisable"
          @click="payInvoice"
          v-if="invoice.state === 'unpaid' && invoice.paypingPaymentId"
        >
          {{ $t('invoices.online_pay') }}
        </vs-button>
        <edit-case-manager-price
          v-if="request.caseManagerUserID === $store.state.AppActiveUser.id"
          :invoice="invoice"
          class="ml-2"
        />
      </vs-row>
    </div>
  </vx-card>
</template>

<script>
import modulePayping from '@/store/payping/modulePayping'
import moduleSurvey from '@/store/survey/moduleSurvey'
import StarRating from 'vue-star-rating'
import InvoiceDataView from './InvoiceDataView'
import EditCaseManagerPrice from '@/views/pages/case-manager/invoice/EditCaseManagerPrice'

export default {
  name: 'InvoiceView',
  components: { InvoiceDataView, StarRating, EditCaseManagerPrice },
  data() {
    return {
      invoice: {},
      request: {},
      requestDetails: null,
      surveyRate: 0,
      surveyRated: 0,
      payBtnDisable: false
    }
  },
  methods: {
    payInvoice() {
      this.payBtnDisable = true

      this.$vs.loading({
        background: 'success',
        container: '#button-pay-loading',
        color: '#fff',
        scale: 0.45
      })

      this.$store
        .dispatch('payping/fetchPaymentIpg', this.invoice.paypingPaymentId)
        .then(response => {
          window.location = response.data
        })
        .finally(() => {
          this.payBtnDisable = false
          this.$vs.loading.close('#button-pay-loading > .con-vs-loading')
        })
    },
    fetchSurvey() {
      // this.$vs.loading({
      //   container: '#star-loading',
      //   scale: 0.45
      // })
      this.$store
        .dispatch('survey/fetchSurveys', {
          query: { requestId: this.invoice.requestId }
        })
        .then(res => {
          if (res.data.length) this.surveyRated = this.surveyRate = res.data[0].score
          // this.$vs.loading.close('#star-loading > .con-vs-loading')
        })
    },
    setRating(rate) {
      if (!this.surveyRated)
        this.$store
          .dispatch('survey/createSurvey', {
            requestId: this.invoice.requestId,
            score: rate
          })
          .then(() => {
            this.surveyRated = rate
          })
    },
    openCancelConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('invoices.cancel'),
        text: this.$t('messages.are_you_sure'),
        accept: () => {
          this.$store
            .dispatch('request/updateRequestBySubject', {
              category: this.request.category,
              subject: this.request.subject,
              id: this.invoice.request.id,
              activity: 'UserCancellation',
              data: {}
            })
            .then(() => {
              this.$notifySuccess(this.$t('services.successfully_canceled'))
            })
        },
        acceptText: this.$t('button.yes'),
        cancelText: this.$t('button.no')
      })
    }
  },
  created() {
    this.$vs.loading()
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    if (!moduleSurvey.isRegistered) {
      this.$store.registerModule('survey', moduleSurvey)
      moduleSurvey.isRegistered = true
    }
    this.$store
      .dispatch('invoice/fetchInvoice', this.$route.params.id)
      .then(res => {
        this.invoice = JSON.parse(JSON.stringify(res.data))
        this.fetchSurvey()

        this.$store
          .dispatch('request/fetchHealthRequestById', this.invoice.request.id)
          .then(res => {
            this.request = JSON.parse(JSON.stringify(res.data))
            this.$store
              .dispatch('request/fetchRequestDetailsBySubject', {
                id: this.invoice.request.id,
                subject: this.request.subject,
                category: this.request.category
              })
              .then(res => {
                this.requestDetails = res.data
              })
          })
          .finally(() => this.$vs.loading.close())
      })
      .catch(() => this.$vs.loading.close())
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>
